module.exports = __webpack_public_path__ + "static/kitchen3-b7488c960cc1bfd5a3a6111600185ad4.jpg";